export const handleResetMboModule = {
  type: 'function',
  required: true,
}
